/* eslint-disable max-lines */
export const es: Record<string, string> = {
  'app.title': 'AutoAcademy',
  'app.subtitle': 'Aprende a conducir de verdad: manual y automático.',
  'app.tagline': 'Suavidad, observación y seguridad. Nunca velocidad.',

  // Menú
  'menu.continue': 'Continuar',
  'menu.levels': 'Niveles',
  'menu.freeDrive': 'Conducción libre',
  'menu.theory': 'Teoría (Módulo 0)',
  'menu.settings': 'Ajustes',
  'menu.controls': 'Controles',
  'menu.track.auto': 'Coche automático',
  'menu.track.manual': 'Coche manual',
  'menu.track.auto.sub': 'P·R·N·D y dos pedales: céntrate en la vía',
  'menu.track.manual.sub': 'Embrague, palanca en H y punto de fricción',
  'menu.trackDone': 'Itinerario completado · Conducción libre',
  'levels.title': 'Currículo de niveles',
  'levels.locked': 'Bloqueado: supera el nivel anterior',
  'levels.best': 'Mejor',
  'levels.xp': 'XP',
  'levels.play': 'Practicar',
  'levels.rank.rookie': 'Aprendiz',
  'levels.rank.learner': 'Conductor novel',
  'levels.rank.solid': 'Conductor seguro',
  'levels.rank.expert': 'Conductor experto',

  // Ajustes
  'settings.title': 'Ajustes',
  'settings.language': 'Idioma',
  'settings.drivingSide': 'Lado de circulación',
  'settings.right': 'Derecha (ES/EU)',
  'settings.left': 'Izquierda (UK/JP)',
  'settings.units': 'Unidades',
  'settings.audio': 'Sonido',
  'settings.on': 'Activado',
  'settings.off': 'Desactivado',
  'settings.camera': 'Cámara por defecto',
  'settings.chase': '3ª persona',
  'settings.cockpit': 'Cabina',
  'settings.reset': 'Borrar progreso',
  'settings.resetConfirm': '¿Seguro? Se borrará todo tu progreso.',
  'settings.back': 'Volver',

  // Coches
  'car.sedan.name': 'Berlina',
  'car.city.name': 'Utilitario urbano',
  'car.ev.name': 'Eléctrico',
  'car.mcity.name': 'Utilitario manual',
  'car.mdiesel.name': 'Furgoneta diésel',
  'car.msport.name': 'Coupé deportivo',
  'car.select': 'Vehículo',
  'car.locked': 'Se desbloquea progresando',

  // Niveles
  'level.l1.title': 'Nivel 1 · Arrancar y detenerse',
  'level.l1.desc':
    'Tu primera vez al volante: cinturón, freno, D, y el coche avanza solo. Acelera con suavidad hasta 20 km/h y detente sin tirones.',
  'level.l2.title': 'Nivel 2 · Volante y carril',
  'level.l2.desc':
    'Da una vuelta completa al circuito manteniéndote dentro del carril. Mirada lejos, manos tranquilas y correcciones pequeñas.',
  'level.l3.title': 'Nivel 3 · Parada en el punto',
  'level.l3.desc':
    'Tres líneas de detención: modula el freno para parar con el morro exactamente sobre cada línea. Frena pronto y suave, afina al final.',
  'level.l4.title': 'Nivel 4 · Giros con observación',
  'level.l4.desc':
    'Espejos – señal – maniobra. Detente en la línea, señaliza y gira a la derecha; vuelve y gira a la izquierda. El examinador mira tus ojos, no solo tu trazada.',
  'level.l5.title': 'Nivel 5 · Marcha atrás',
  'level.l5.desc':
    'Retrocede recto por el pasillo de conos y aparca marcha atrás en la plaza. Despacio: en marcha atrás, la velocidad es tu enemiga.',
  'level.free.title': 'Conducción libre',
  'level.free.desc':
    'Sin objetivos ni puntuación. Practica lo que quieras: circuito, eslalon, la plaza de aparcamiento o la rampa para el arranque en cuesta.',

  // Niveles MANUALES
  'level.m1.title': 'Manual 1 · El punto de fricción',
  'level.m1.desc':
    'La lección más importante del cambio manual: siente dónde el embrague "muerde". Aguanta el coche casi quieto solo con el pedal, sin freno y sin calarte.',
  'level.m2.title': 'Manual 2 · Arrancar sin calarse',
  'level.m2.desc':
    'La danza de los dos pies: punto de fricción, un hilo de gas y soltar despacio. Tres salidas seguidas, cada vez más limpias.',
  'level.m3.title': 'Manual 3 · Detenerse sin calarse',
  'level.m3.desc':
    'Frenar es fácil; lo difícil es pisar el embrague en el momento justo. Tres líneas de detención: si el coche tiembla, llegas tarde.',
  'level.m4.title': 'Manual 4 · Subir marchas',
  'level.m4.desc':
    'De 1ª a 4ª siguiendo el tacómetro y el oído: embrague a fondo, palanca, y soltar mientras aceleras. Sin tirones y sin pasarte de vueltas.',
  'level.m5.title': 'Manual 5 · Reducir y freno motor',
  'level.m5.desc':
    'Entra una zona a 30: reduce a tiempo y deja que el motor frene por ti. Termina parado en la línea con la marcha correcta.',
  'level.m6.title': 'Manual 6 · Arranque en cuesta',
  'level.m6.desc':
    'La prueba clásica del manual. Para en plena pendiente y sal con freno de mano, punto de fricción y gas, sin retroceder ni medio metro.',
  'level.m7.title': 'Manual 7 · Examen del embrague',
  'level.m7.desc':
    'Recorrido completo con parada en STOP incluida: marchas correctas, embrague fino, observación y cero caladas. Apruébalo y el manual es tuyo.',
  'level.freeManual.title': 'Explanada manual',
  'level.freeManual.desc':
    'Practica libre con el coche manual: rampas del 9 % y el 16 % para la cuesta, eslalon de conos y plaza de aparcamiento. Sin puntuación.',

  // Objetivos MANUALES
  'obj.m1.gear1': 'Pisa el embrague (Shift) y engrana 1ª',
  'obj.m1.bite': 'Aguanta el coche 3 s en el punto de fricción (sin freno)',
  'obj.m1.go': 'Suelta del todo, con algo de gas, y avanza',
  'obj.m1.stop': 'Pisa embrague y freno: detente sin calar',
  'obj.m1.neutral': 'Deja la palanca en punto muerto (N)',
  'obj.m2.gear1': 'Embrague a fondo y 1ª',
  'obj.m2.go15': 'Arranca con suavidad hasta 15 km/h',
  'obj.m2.stop': 'Detente sin calarte (embrague antes de parar)',
  'obj.m2.again1': 'Otra vez: embrague y 1ª',
  'obj.m2.again2': 'Última: embrague y 1ª',
  'obj.m2.go20': 'Arranca y llega a 20 km/h',
  'obj.m2.neutral': 'Punto muerto (N) para terminar',
  'obj.m3.gear1': 'Embrague y 1ª',
  'obj.m3.go': 'Acelera hasta 20 km/h',
  'obj.m3.go25': 'Acelera hasta 25 km/h',
  'obj.m3.stopA': 'Para en la línea A sin calarte',
  'obj.m3.stopB': 'Para en la línea B sin calarte',
  'obj.m3.stopC': 'Para en la línea C sin calarte',
  'obj.m3.neutral': 'Punto muerto (N)',
  'obj.m4.gear1': 'Embrague y 1ª',
  'obj.m4.go': 'Arranca hasta 15 km/h',
  'obj.m4.gear2': 'Sube a 2ª (embrague a fondo, palanca, soltar)',
  'obj.m4.sp30': 'Acelera en 2ª hasta 30 km/h',
  'obj.m4.gear3': 'Sube a 3ª',
  'obj.m4.sp45': 'Acelera hasta 45 km/h',
  'obj.m4.gear4': 'Sube a 4ª',
  'obj.m4.sp60': 'Llega a 58 km/h en 4ª',
  'obj.m4.stop': 'Frena y detente (embrague al final)',
  'obj.m4.neutral': 'Punto muerto (N)',
  'obj.m5.gear1': 'Embrague y 1ª',
  'obj.m5.go': 'Arranca hasta 15 km/h',
  'obj.m5.gear3': 'Sube marchas hasta 3ª',
  'obj.m5.sp50': 'Acelera hasta ~50 km/h',
  'obj.m5.gear4': 'Sube a 4ª',
  'obj.m5.down3': 'Zona 30 a la vista: reduce a 3ª (bajo 45 km/h)',
  'obj.m5.down2': 'Reduce a 2ª y deja que el motor retenga (bajo 32 km/h)',
  'obj.m5.stopLine': 'Detente en la línea de STOP',
  'obj.m5.neutral': 'Punto muerto (N)',
  'obj.m6.gear1': 'Espejos, embrague y 1ª',
  'obj.m6.base': 'Acércate a la base de la cuesta',
  'obj.m6.stopSlope': 'PARA por completo en la zona marcada de la pendiente',
  'obj.m6.hill': 'Sal en cuesta sin retroceder más de 40 cm',
  'obj.m6.top': 'Corona la cuesta hasta la meseta',
  'obj.m6.stopTop': 'Detente arriba',
  'obj.m6.neutral': 'Punto muerto y freno de mano',
  'obj.m7.gear1': 'Espejos, embrague y 1ª',
  'obj.m7.lapA': 'Recorre el circuito hasta el STOP, en la marcha adecuada',
  'obj.m7.stop1': 'Detente por completo en la línea del STOP',
  'obj.m7.resume': 'Reanuda la marcha sin calarte',
  'obj.m7.lapB': 'Completa la vuelta hasta la meta',
  'obj.m7.stop2': 'Detente por completo',
  'obj.m7.neutral': 'Punto muerto (N): examen terminado',

  // Objetivos
  'obj.l1.prep': 'Ponte el cinturón (B), mira espejos, pisa el freno y pasa a D',
  'obj.l1.go': 'Acelera con suavidad hasta 20 km/h',
  'obj.l1.stop': 'Detente por completo, sin frenazos',
  'obj.l1.park': 'Pon P para aparcar',
  'obj.l2.prep': 'Cinturón, espejos, freno y D',
  'obj.l2.lap': 'Completa una vuelta sin salirte del carril',
  'obj.l2.stop': 'Detente por completo',
  'obj.l2.park': 'Pon P',
  'obj.l3.prep': 'Cinturón, espejos, freno y D',
  'obj.l3.go': 'Alcanza 25 km/h',
  'obj.l3.go2': 'Alcanza 30 km/h',
  'obj.l3.stopA': 'Para con el morro sobre la línea A',
  'obj.l3.stopB': 'Para con el morro sobre la línea B',
  'obj.l3.stopC': 'Para con el morro sobre la línea C',
  'obj.l3.park': 'Pon P',
  'obj.l4.prep': 'Cinturón, espejos, freno y D',
  'obj.l4.approach': 'Acércate al cruce con calma',
  'obj.l4.stop1': 'Señaliza a la derecha, mira espejos y para en la línea',
  'obj.l4.turnR': 'Gira a la derecha siguiendo el carril',
  'obj.l4.loop': 'Da la vuelta al fondo de la vía',
  'obj.l4.stop2': 'Señaliza a la izquierda, mira espejos y para en el ceda',
  'obj.l4.turnL': 'Gira a la izquierda e incorpórate',
  'obj.l4.stop3': 'Detente por completo',
  'obj.l4.park': 'Pon P',
  'obj.l5.prepR': 'Mira los TRES espejos, pisa freno y engrana R',
  'obj.l5.backA': 'Retrocede recto hasta la zona marcada',
  'obj.l5.fwd': 'Frena y vuelve a D',
  'obj.l5.preBay': 'Avanza y rebasa la plaza de aparcamiento',
  'obj.l5.prepR2': 'Espejos derecho y trasero, y engrana R',
  'obj.l5.bay': 'Aparca marcha atrás dentro de la plaza',
  'obj.l5.park': 'Pon P: coche aparcado',

  // HUD
  'hud.objectives': 'Objetivos',
  'hud.time': 'Tiempo',
  'hud.collisions': 'Golpes',
  'hud.abs': 'ABS',
  'hud.tc': 'TC',
  'hud.hillhold': 'HOLD',
  'hud.handbrake': 'FRENO MANO',
  'hud.belt': 'CINTURÓN',
  'hud.shifting': 'Cambiando…',
  'hud.mirror.left': 'Espejo izquierdo',
  'hud.mirror.right': 'Espejo derecho',
  'hud.mirror.rear': 'Espejo interior',
  'hud.reverseCam': 'Cámara trasera',
  'hud.stalls': 'Caladas',
  'hud.stalled': '¡MOTOR CALADO!',
  'hud.stalledHelp': 'Embrague a fondo (Shift) y mantén F para arrancar. En táctil: mantén 🔑.',
  'hud.cranking': 'Arrancando…',
  'hud.engine': 'MOTOR',
  'hud.clutchHot': 'EMBR 🔥',
  'hud.pedal.clutch': 'EMB',
  'hud.pedal.brake': 'FRE',
  'hud.pedal.throttle': 'ACE',

  // Controles táctiles
  'touch.controls': 'Controles táctiles de conducción',
  'touch.brake': 'FRENO',
  'touch.throttle': 'ACELERA',
  'touch.steer.left': 'Girar a la izquierda',
  'touch.steer.right': 'Girar a la derecha',
  'touch.signal.left': 'Intermitente izquierdo',
  'touch.signal.right': 'Intermitente derecho',
  'touch.mirror.left': 'IZQ',
  'touch.mirror.rear': 'CENTRO',
  'touch.mirror.right': 'DER',
  'touch.gear': 'Marcha',
  'touch.gearDown': 'Bajar marcha',
  'touch.gearUp': 'Subir marcha',
  'touch.clutch': 'EMBRAGUE',
  'touch.ignition': 'Arrancar el motor',

  // Pistas de requisitos
  'hint.signal.left': 'Señaliza a la IZQUIERDA (Q)',
  'hint.signal.right': 'Señaliza a la DERECHA (E)',
  'hint.glance.left': 'Mira el espejo izquierdo (Z)',
  'hint.glance.right': 'Mira el espejo derecho (C)',
  'hint.glance.rear': 'Mira el espejo interior (X)',
  'hint.slowDown': 'Reduce la velocidad',
  'hint.clutchToShift': 'Pisa el embrague (Shift) para mover la palanca',
  'hint.clutchToStart': 'Pisa el embrague a fondo (Shift) para poder arrancar',
  'hint.restart': 'Mantén F (o 🔑) para arrancar el motor',
  'hint.gearFirst': 'Engrana 1ª: embrague a fondo y tecla 1',
  'hint.handbrakeOff': 'Quita el freno de mano (Espacio)',
  'hint.releaseBrake': 'Suelta el pedal de freno',
  'hint.easeClutchOut': 'Ve soltando el embrague (Ctrl) hasta notar que muerde',
  'hint.moreClutch': 'Has soltado de más: pisa un poco el embrague (Shift)',
  'hint.throttleAndEase': 'Un poco de gas y suelta el embrague muy despacio',
  'hint.stopOnSlope': 'Detente por completo dentro de la zona de la cuesta',
  'hint.useHandbrake': 'Pon el freno de mano (Espacio) mientras preparas la salida',
  'hint.releaseHandbrake': 'Con el embrague mordiendo y algo de gas, suelta el freno de mano',

  // Avisos
  'warn.coneHit': 'Has tocado un cono',
  'warn.collision': '¡Colisión!',
  'warn.harshAccel': 'Acelerón: dosifica el pedal',
  'warn.harshBrake': 'Frenazo: frena antes y más suave',
  'warn.seatbelt': 'Ponte el cinturón (B)',
  'warn.speeding': 'Exceso de velocidad',
  'warn.laneDeparture': 'Te estás saliendo del carril',
  'warn.stall': 'Te has calado: embrague a fondo y arranca de nuevo',
  'warn.grind': '¡Rascada! Pisa el embrague a fondo antes de mover la palanca',
  'warn.overRev': '¡Pasado de vueltas! Sube de marcha o levanta el pie',
  'warn.lugging': 'Motor ahogado: reduce a una marcha más corta',
  'warn.clutchHeat': 'Embrague recalentado: no lo lleves a medio pisar',
  'warn.rollback': 'Has retrocedido: usa freno de mano y punto de fricción',
  'warn.crankBlocked': 'Para arrancar: embrague a fondo o punto muerto',
  'deny.brakeRequired': 'Pisa el freno para salir de P',
  'deny.moving': 'No puedes engranar esa marcha en movimiento',
  'deny.shifting': 'Espera al cambio',
  'deny.clutchRequired': 'Pisa el embrague para cambiar de marcha',

  // Debrief
  'debrief.passed': '¡Nivel superado!',
  'debrief.failed': 'Nivel no superado',
  'debrief.score': 'Puntuación',
  'debrief.smoothness': 'Suavidad',
  'debrief.observation': 'Observación',
  'debrief.rules': 'Normas',
  'debrief.speed': 'Velocidad',
  'debrief.collisions': 'Colisiones',
  'debrief.time': 'Tiempo',
  'debrief.tips': 'Consejos del instructor',
  'debrief.failures': 'Motivos',
  'debrief.retry': 'Reintentar',
  'debrief.next': 'Siguiente nivel',
  'debrief.menu': 'Menú',
  'debrief.xp': 'XP ganada',
  'debrief.stalls': 'Caladas',
  'debrief.clutch': 'Embrague',
  'debrief.gears': 'Marchas',
  'debrief.rollback': 'Retroceso',

  'fail.collisions': 'Demasiadas colisiones',
  'fail.timeout': 'Tiempo agotado',
  'fail.incomplete': 'Objetivos incompletos',
  'fail.harshAccel': 'Demasiados acelerones',
  'fail.harshBrake': 'Demasiados frenazos',
  'fail.observation': 'Observación insuficiente (espejos)',
  'fail.speeding': 'Exceso de velocidad repetido',
  'fail.lowScore': 'Puntuación global insuficiente',
  'fail.stalls': 'Demasiadas caladas',
  'fail.gearScore': 'Demasiado tiempo en una marcha inadecuada',
  'fail.clutchScore': 'Control del embrague insuficiente',
  'fail.rollback': 'Retroceso excesivo en la cuesta',

  'tip.brakeEarlier':
    'Frena antes y con menos presión: pisa, mantén y afloja al final para parar sin tirón.',
  'tip.progressiveThrottle':
    'Acelera como si tuvieras un huevo bajo el pedal: presión progresiva, no golpes.',
  'tip.mirrors':
    'Antes de cualquier maniobra: espejo interior, espejo del lado y ángulo muerto. Que mirar sea un hábito.',
  'tip.signals': 'Señaliza siempre antes de girar o cambiar de carril, con tiempo suficiente.',
  'tip.references': 'Usa referencias: conos, líneas y espejos te dicen dónde están tus ruedas.',
  'tip.seatbelt': 'El cinturón, siempre antes de mover el coche.',
  'tip.great': 'Conducción limpia. Así se hace: suave, atento y previsible.',
  'tip.stall':
    'Para no calarte: embrague hasta el punto de fricción, un hilo de gas, y suelta MUY despacio los primeros centímetros. Si el coche tiembla, pisa embrague de nuevo.',
  'tip.hillStart':
    'En cuesta: freno de mano puesto, busca el punto de fricción, algo de gas, y suelta el freno de mano solo cuando notes que el coche "quiere" avanzar.',
  'tip.clutchHeat':
    'No conduzcas con el embrague a medio pisar: o pisado a fondo o suelto del todo. A medias solo debe estar al arrancar y maniobrar.',
  'tip.grind':
    'La palanca solo se mueve con el embrague pisado A FONDO. Embrague, marcha, y soltar: en ese orden.',
  'tip.gearChoice':
    'Escucha el motor y mira el tacómetro: si ruge, sube de marcha; si se ahoga por debajo de ~1200 rpm, reduce.',
  'tip.greatManual':
    'Embrague fino, marchas a tiempo y cero caladas: eso es conducir un manual de verdad. Enhorabuena.',

  // Pausa
  'pause.title': 'Pausa',
  'pause.resume': 'Continuar',
  'pause.restart': 'Reiniciar nivel',
  'pause.exit': 'Salir al menú',

  // Intro de nivel
  'intro.theory': 'Antes de conducir',
  'intro.objectives': 'Objetivos del nivel',
  'intro.start': 'Conducir',
  'intro.back': 'Volver',
  'intro.car': 'Vehículo',

  // Controles
  'controls.title': 'Controles',
  'controls.keyboard': 'Teclado',
  'controls.gamepad': 'Mando',
  'controls.throttle': 'Acelerar',
  'controls.brake': 'Frenar',
  'controls.clutch': 'Embrague: PISAR',
  'controls.clutchFeed': 'Embrague: SOLTAR gradual',
  'controls.steer': 'Dirección',
  'controls.gearsManual': 'Marchas manuales (caja en H)',
  'controls.gearsSeq': 'Cambio secuencial',
  'controls.gears': 'Selector automático P·R·N·D',
  'controls.ignition': 'Arrancar el motor',
  'controls.handbrake': 'Freno de mano',
  'controls.signals': 'Intermitentes izq./dcha.',
  'controls.glance': 'Espejos: izq. / interior / dcho.',
  'controls.lights': 'Luces',
  'controls.horn': 'Claxon',
  'controls.belt': 'Cinturón',
  'controls.camera': 'Cambiar cámara',
  'controls.pause': 'Pausa',
  'controls.kb.throttle': 'W o ↑',
  'controls.kb.brake': 'S o ↓',
  'controls.kb.clutch': 'Shift (mantener)',
  'controls.kb.clutchFeed': 'Ctrl (mantener)',
  'controls.kb.steer': 'A / D o ← / →',
  'controls.kb.gearsManual': 'Teclas 1–6 · R · N',
  'controls.kb.gearsSeq': 'J (bajar) / K (subir)',
  'controls.kb.gears': 'Teclas P, R, N, D',
  'controls.kb.ignition': 'F (mantener)',
  'controls.kb.handbrake': 'Espacio',
  'controls.kb.signals': 'Q / E',
  'controls.kb.glance': 'Z / X / C',
  'controls.kb.lights': 'L',
  'controls.kb.horn': 'H',
  'controls.kb.belt': 'B',
  'controls.kb.camera': 'V',
  'controls.kb.pause': 'Esc',
  'controls.gp.throttle': 'Gatillo derecho (RT)',
  'controls.gp.brake': 'Gatillo izquierdo (LT)',
  'controls.gp.clutch': 'X (mantener)',
  'controls.gp.clutchFeed': 'Automático al soltar X',
  'controls.gp.steer': 'Stick izquierdo',
  'controls.gp.gearsManual': 'LB (bajar) / RB (subir)',
  'controls.gp.gearsSeq': 'LB / RB',
  'controls.gp.gears': 'LB / RB',
  'controls.gp.ignition': 'A (mantener)',
  'controls.gp.handbrake': 'Botón B',
  'controls.gp.signals': 'Cruceta ← / →',
  'controls.gp.glance': 'Stick derecho',
  'controls.gp.lights': 'Cruceta ↑',
  'controls.gp.horn': 'Pulsar stick derecho (R3)',
  'controls.gp.belt': 'Cruceta ↓',
  'controls.gp.camera': 'Botón Y',
  'controls.gp.pause': 'Start',
  'controls.clutchTip.title': 'Cómo funciona el embrague sin pedal real',
  'controls.clutchTip.body':
    'Shift PISA el embrague (rápido, como un pie de verdad). Al soltar Shift a baja velocidad, el pedal SE QUEDA donde está: usa Ctrl para irlo SOLTANDO de forma gradual y encontrar el punto de fricción. Con el coche ya rodando, la suelta es automática. En pantalla táctil, el deslizador EMBRAGUE es analógico: arrástralo a la zona verde y notarás dónde muerde. Con mando, mantén X y suéltalo: el pedal saldrá solo con suavidad.',
  'controls.wheel':
    'Volante y pedales USB: si tu volante se presenta como mando (la mayoría por Gamepad API), gatillos y stick ya funcionan. El embrague analógico por WebHID llegará en una fase futura.',

  // Teoría — Módulo 0
  'theory.title': 'Módulo 0 · Antes de conducir',
  'theory.intro':
    'Diez minutos de teoría que te ahorrarán horas de vicios. Léelo una vez; el simulador te lo recordará mientras conduces.',
  'theory.manualBlock': 'Cambio manual: embrague y caja',
  'theory.commonBlock': 'Fundamentos comunes',

  // Teoría — cambio manual
  'theory.clutch.title': 'Para qué sirve el embrague',
  'theory.clutch.body':
    'El motor nunca deja de girar; las ruedas sí. El embrague es el puente entre ambos: pisado, los separa; suelto, los une. Soltarlo de golpe une dos mundos a velocidades distintas: tirón… o calada. Toda la técnica del manual consiste en unirlos CON SUAVIDAD.',
  'theory.bitepoint.title': 'El punto de fricción',
  'theory.bitepoint.body':
    'A mitad del recorrido del pedal hay un punto donde el embrague empieza a "morder" y el coche quiere avanzar. Ahí vive la magia: el morro se levanta un poco, el motor baja de vueltas y el coche empuja. En el simulador, la franja del pedal EMB se ilumina en verde al estar en la zona.',
  'theory.hpattern.title': 'La caja en H',
  'theory.hpattern.body':
    'Las marchas se ordenan en forma de H: 1-2 a la izquierda, 3-4 en el centro, 5-6 a la derecha, R aparte, y el punto muerto (N) en la barra central. Regla de oro: la palanca SOLO se mueve con el embrague pisado a fondo; si no, rasca.',
  'theory.stalling.title': 'Por qué se cala el motor',
  'theory.stalling.body':
    'Por debajo de unas ~600 rpm el motor no puede con la carga y se apaga. Pasa si sueltas el embrague deprisa sin gas, si frenas hasta parar sin pisar embrague o si sales en marcha larga. Para recuperarte: embrague a fondo, arranca (F), y de nuevo al punto de fricción. Calarse es parte de aprender.',
  'theory.moveoff.title': 'Arrancar desde parado',
  'theory.moveoff.body':
    'La secuencia: embrague a fondo → 1ª → un hilo de gas (~1500 rpm) → suelta hasta el punto de fricción → deja que el coche empiece a rodar → termina de soltar MUY despacio mientras das gas. Los primeros centímetros de pedal son los que deciden todo.',
  'theory.stopManual.title': 'Detenerse sin calar',
  'theory.stopManual.body':
    'Frena con el pie derecho y, ANTES de que el motor tiemble (por debajo de ~15 km/h en 1ª-2ª), pisa el embrague a fondo con el izquierdo. Parado: freno pisado, 1ª o N. Si notas el temblor del coche, te queda medio segundo para salvarlo.',
  'theory.upshift.title': 'Subir marchas',
  'theory.upshift.body':
    'Cuando el tacómetro pase de ~2500-3000 rpm (o el motor "ruja"): gas fuera, embrague a fondo, palanca a la siguiente, y soltar el embrague mientras recuperas gas. Con el coche en movimiento la suelta puede ser mucho más rápida que al arrancar.',
  'theory.downshift.title': 'Reducir y freno motor',
  'theory.downshift.body':
    'Reducir a tiempo te da control: el motor retiene al soltar el gas (freno motor) y te deja la marcha correcta para reaccionar. Frena, embrague, palanca a la marcha inferior y suelta con calma: las rpm subirán solas al engranar.',
  'theory.revmatch.title': 'Rev-matching (toque de gas)',
  'theory.revmatch.body':
    'Al reducir, la marcha corta pide más vueltas. Si das un toque de gas con el embrague pisado justo antes de soltarlo, igualas las velocidades y el cambio entra fino, sin tirón. Es técnica avanzada: el deportivo la agradece especialmente.',
  'theory.hillstart.title': 'El arranque en cuesta',
  'theory.hillstart.body':
    'La prueba reina. Con freno de mano puesto: 1ª, gas moderado (~2000 rpm), suelta hasta el punto de fricción y ESPERA a notar que el coche "tira" hacia delante. Solo entonces suelta el freno de mano. Sin la técnica, el coche se va hacia atrás.',
  'theory.handbrakeM.title': 'El freno de mano, tu tercer pie',
  'theory.handbrakeM.body':
    'En cuesta el freno de mano sujeta el coche mientras tus dos pies se ocupan del embrague y del gas. Úsalo SIEMPRE en pendientes fuertes y al aparcar (junto con dejar una marcha engranada: 1ª cuesta arriba, R cuesta abajo).',
  'theory.ecoShift.title': 'Cambiar para consumir menos',
  'theory.ecoShift.body':
    'Un motor a media carga y pocas vueltas (~2000 rpm) gasta menos: sube de marcha pronto, anticipa para no frenar de más y usa el freno motor. Ni ahogado (por debajo de ~1200 rpm con gas) ni pasado de vueltas: la franja media es la eficiente.',
  'theory.seat.title': 'Asiento, espejos y cinturón',
  'theory.seat.body':
    'Ajusta el asiento para pisar el freno a fondo sin estirar la pierna. Regula los tres espejos para cubrir el máximo ángulo. Cinturón SIEMPRE antes de mover el coche: en el simulador, tecla B.',
  'theory.mirrors.title': 'Los tres espejos',
  'theory.mirrors.body':
    'Interior: ¿qué hay detrás? Izquierdo y derecho: ¿qué hay a los lados y en el ángulo muerto? En el simulador miras con Z (izq.), X (interior) y C (dcho.), y el examinador cuenta tus miradas.',
  'theory.dashboard.title': 'El tablero y los testigos',
  'theory.dashboard.body':
    'Velocímetro, cuentarrevoluciones, marcha engranada e indicadores: ABS (pulso al frenar fuerte), TC (control de tracción) y HOLD (retención en cuesta). Si un testigo parpadea, el coche te está hablando.',
  'theory.prnd.title': 'Qué significa P · R · N · D',
  'theory.prnd.body':
    'P (Park) bloquea la transmisión: solo con el coche parado. R es marcha atrás: nunca en movimiento hacia delante. N es punto muerto. D es conducir. Para salir de P debes pisar el freno: el simulador aplica los mismos bloqueos que un coche real.',
  'theory.pedals.title': 'Dos pedales, un solo pie',
  'theory.pedals.body':
    'En un automático el pie derecho lo hace todo: acelerador y freno. El izquierdo descansa SIEMPRE. Así es imposible pisar los dos a la vez, y tu frenada será la misma que en cualquier coche.',
  'theory.creep.title': 'El coche "avanza solo" (creep)',
  'theory.creep.body':
    'En D o R, al soltar el freno, un automático avanza despacio sin acelerar. Se usa para maniobrar y aparcar: controla el creep solo con el freno.',
  'theory.msm.title': 'Espejos – Señal – Maniobra',
  'theory.msm.body':
    'La regla de oro. Primero MIRA (interior y del lado), después SEÑALIZA con tiempo, y solo entonces MANIOBRA. En ese orden, siempre. Los examinadores suspenden más por no mirar que por no trazar.',
  'theory.signals.title': 'Intermitentes',
  'theory.signals.body':
    'Señaliza antes de girar, cambiar de carril o salir de un estacionamiento. En el simulador: Q izquierda, E derecha. Se cancelan solos al deshacer el giro, como en un coche real.',
  'theory.steering.title': 'El volante',
  'theory.steering.body':
    'Mira lejos, hacia donde quieres ir: las manos siguen a los ojos. Correcciones pequeñas y continuas; si entras pasado de velocidad, el coche subvira y se abre. La velocidad se decide ANTES de la curva.',
  'theory.lane.title': 'Posición en el carril',
  'theory.lane.body':
    'Centra el coche entre las líneas. Referencia: el borde izquierdo del capó cerca de la línea central. Si tocas una línea, corrige suave, nunca con un volantazo.',
  'theory.braking.title': 'Frenar bien',
  'theory.braking.body':
    'Frena en tres fases: pisa firme al principio, mantén, y AFLOJA justo antes de parar para evitar el tirón. Si el ABS pulsa bajo tu pie, mantén la presión: está trabajando por ti.',
  'theory.stopLine.title': 'Parar en la línea',
  'theory.stopLine.body':
    'La parada es total (velocidad cero), con el morro sobre la línea sin rebasarla. Cuenta "uno" parado antes de continuar.',
  'theory.stopSign.title': 'STOP y ceda el paso',
  'theory.stopSign.body':
    'STOP: detención total obligatoria, siempre. Ceda: reduce y detente solo si viene alguien. En ambos, la observación es lo que puntúa.',
  'theory.speed.title': 'Límites de velocidad',
  'theory.speed.body':
    'El límite es un máximo, no un objetivo. En zonas de prácticas circula muy por debajo. Este simulador nunca premia la velocidad: premia el control.',
  'theory.distance.title': 'Distancia de seguridad',
  'theory.distance.body':
    'Regla de los dos segundos con el vehículo de delante; el doble con lluvia. La distancia es tu tiempo de reacción convertido en metros.',
  'theory.reverse.title': 'Marcha atrás',
  'theory.reverse.body':
    'Antes de engranar R: espejo interior, ambos laterales y giro de cabeza. Retrocede a paso de persona, guiándote por los espejos. Pequeños toques de volante: en marcha atrás todo se amplifica.',
  'theory.reverseCam.title': 'Cámara y sensores',
  'theory.reverseCam.body':
    'La cámara trasera ayuda, pero no sustituye a los espejos ni al giro de cabeza: tiene ángulos muertos. Úsala como una referencia más.',
  'theory.priorities.title': 'Prioridades de paso',
  'theory.priorities.body':
    'Sin señales, prioridad a la derecha. Con señales, mandan ellas. En glorietas, quien circula dentro tiene prioridad. Ante la duda: cede y mantén siempre una salida.',

  // Comunes
  'common.loading': 'Cargando física…',
  'common.close': 'Cerrar',
  'common.km': 'km',
  'common.kmh': 'km/h',
  'common.mph': 'mph',
};
